import * as bi from 'react-bootstrap-icons';
import { IClientPassengerBrief } from '@bustickus/models-client';
import { Box, Button, Flex, Header } from 'components';
import './style.scss';
import { PassengerDocuments } from './components';
import { Icon } from 'shared/components';

interface IProps {
  passenger: IClientPassengerBrief;
  onEditClick: () => void;
  onDeleteClick: () => void;
}

function PassengerCard(props: IProps) {
  return (
    <Box
      padding={20}
      className='passenger-bSK8'
      onClick={props.onEditClick}
    >
      <Flex
        direction='column'
        gap={10}
      >
        <Flex direction='column'>
          <Flex
            gap={5}
            justifyContent='space-between'
          >
            <Header
              element='div'
              className='passenger-title-Ml1A'
            >
              {props.passenger.name}
            </Header>
            <Button
              color='transparent-red'
              size='small'
              onClick={props.onDeleteClick}
            >
              <bi.XLg />
            </Button>
          </Flex>
          <Flex gap={5}>
            <Icon color='red'>
              {props.passenger.gender === 'male' && <bi.GenderMale />}
              {props.passenger.gender === 'female' && <bi.GenderFemale />}
            </Icon>
            <div>{parseBirthDate(props.passenger)}</div>
          </Flex>
        </Flex>
        {(props.passenger.passport != null ||
          props.passenger.foreignPassport != null ||
          props.passenger.visas.length > 0) && <PassengerDocuments passenger={props.passenger} />}
      </Flex>
    </Box>
  );
}

function parseBirthDate(passenger: IClientPassengerBrief): string {
  const birthDate = new Date(passenger.birthDate);
  const month = parseMonth(birthDate);
  const day = parseDate(birthDate);
  return `${day} ${month} ${birthDate.getUTCFullYear()}`;
}

function parseDate(date: Date): string {
  const day = date.getUTCDate().toString();
  return day.length === 1 ? `0${day}` : day;
}

function parseMonth(date: Date): string {
  const month = date.getUTCMonth();

  if (month === 0) {
    return 'января';
  }

  if (month === 1) {
    return 'февраля';
  }

  if (month === 2) {
    return 'марта';
  }

  if (month === 3) {
    return 'апреля';
  }

  if (month === 4) {
    return 'мая';
  }

  if (month === 5) {
    return 'июня';
  }

  if (month === 6) {
    return 'июля';
  }

  if (month === 7) {
    return 'августа';
  }

  if (month === 8) {
    return 'сентября';
  }

  if (month === 9) {
    return 'октября';
  }

  if (month === 10) {
    return 'ноября';
  }

  if (month === 11) {
    return 'декабря';
  }

  return 'N/A';
}

export default PassengerCard;
